export default class DocumentLifecycle {
    constructor (dto) {
        this.id = 0
        this.description = ''
        this.defFieldCode = ''
        this.type = null
        this.preservationMonths = ''
        this.contentTypeId = null
        this.conditionStr = ''
        this.displayConditionStr = ''

        if (dto) {
            this.id = dto.Id
            this.description = dto.Description
            this.defFieldCode = dto.DefFieldCode
            this.type = dto.Type
            this.preservationMonths = dto.PreservationMonths
            this.contentTypeId = dto.ContentTypeID + ''
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
        }
    }

    toDto () {
        return {
            Id: this.id,
            Description: this.description,
            DefFieldCode: this.defFieldCode,
            Type: this.type,
            PreservationMonths: this.preservationMonths,
            ContentTypeID: this.contentTypeId,
            ConditionStr: this.conditionStr,
        }
    }
}
